import dynamic from "next/dynamic";

export const ModalKycGuide = dynamic(() => import("./ModalKycGuide"), {
  ssr: false
});
